<template>
  <div class="myyq">
    <div class="banner">
      <div class="img">
        <img src="../../assets/myyq3.jpg" />
        <!-- <img :src="this.$store.getters.banner[this.$route.path]" /> -->
      </div>
    </div>
    <div class="content">
      <p class="title">墓园园区</p>
      <div class="contentDiv">
        <div class="contentTxt" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'muyuanyuanqu',

  data() {
    return {
      content: '',
    }
  },
  created() {
    var that = this
    this.$queryOne('OweArticle', { code: 'MYYQ' }, ['content'], function(res) {
      that.content = res.data['content']
    })
  },
  methods: {},
}
</script>

<style>
.myyq .content {
  padding: 0.67rem 0.4rem;
  background: #fff;
}
.myyq .banner {
  height: 3.73rem;
}
.myyq .title {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
  margin-left: 0.5rem;
  margin-bottom: 0.53rem;
}
.myyq .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.myyq .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.myyq .contentTxt {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  /* white-space: pre-wrap; */
  word-wrap: break-word;
}
.myyq .contentTxt p {
  margin: 0.5rem 0;
  color: #666;
  line-height: 0.7rem;
}
</style>
